import { render } from "./StatisticsManage.vue?vue&type=template&id=26432366&scoped=true"
import script from "./StatisticsManage.vue?vue&type=script&lang=js"
export * from "./StatisticsManage.vue?vue&type=script&lang=js"

import "./StatisticsManage.vue?vue&type=style&index=0&id=26432366&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-26432366"

export default script